interface MetadataItemProps {
  label: string;
  children: React.ReactNode;
  condition?: boolean;
}

export default function MetadataItem({ label, children, condition = true }: MetadataItemProps) {
  if (!condition) return null;

  return (
    <ul className="flex flex-col text-sm gap-0.5">
      <li className="font-bold">{label}:</li>
      <li className="font-normal">{children}</li>
    </ul>
  );
}
